/**
 * `<RetireSigningKeyDialog>` — typed-confirm retire flow. Phrase = `kid`.
 * Highest friction per NFR-SEC-16: retire invalidates host integrations.
 */

import { useTranslation } from "react-i18next";

import { TypedConfirmDialog } from "../common/TypedConfirmDialog";

export interface RetireSigningKeyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  kid: string;
  busy?: boolean;
  onConfirm: () => void;
}

export function RetireSigningKeyDialog({
  open,
  onOpenChange,
  kid,
  busy = false,
  onConfirm,
}: RetireSigningKeyDialogProps) {
  const { t } = useTranslation("signing-keys");
  return (
    <TypedConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("retire.title", { kid })}
      body={t("retire.body")}
      confirmationPhrase={kid}
      inputLabel={t("retire.typedLabel", { kid })}
      confirmLabel={t("retire.confirm")}
      destructive
      busy={busy}
      onConfirm={onConfirm}
      testId="retire-signing-key-dialog"
    />
  );
}
